const Layout = () => import('@/layout/index.vue')

export default {
    path: '/agent',
    component: Layout,
    redirect: '/agent/setting',
    name: 'Agent',
    meta: {
        title: '代理管理',
        icon: 'users-agent',
        defaultOpened: true,
        auth: ['Agent']
    },
    children: [
        // {
        //     path: 'code',
        //     name: 'AgentCode',
        //     component: () => import('@/views/agent/code/index.vue'),
        //     meta: {
        //         title: '兑换码明细',
        //         icon: 'agent-code'
        //     }
        // }
        // {
        //     path: 'point',
        //     name: 'AgentPoint',
        //     component: () => import('@/views/agent/point/index.vue'),
        //     meta: {
        //         title: '积分明细',
        //         icon: 'agent-point'
        //     }
        // }
        {
            path: 'setting',
            name: 'AgentSetting',
            component: () => import('@/views/agent/setting/index.vue'),
            meta: {
                title: '代理设置',
                icon: 'agent-code',
                auth: ['AgentSetting']
            }
        },
        {
            path: 'list',
            name: 'AgentList',
            component: () => import('@/views/agent/list/index.vue'),
            meta: {
                title: '代理列表',
                icon: 'device-log',
                auth: ['AgentList']
            }
        },
        {
            path: 'withdraw',
            name: 'AgentWithdraw',
            component: () => import('@/views/agent/withdraw/index.vue'),
            meta: {
                title: '代理提现',
                icon: 'code-member',
                auth: ['AgentWithdraw']
            }
        }

    ]
}
